import { useEffect, useState } from 'react';

/**
 * Retourne une valeur debouncée lorsque `enabled` est true ; sinon la valeur immédiate.
 */
export function useU3204DebouncedValue<T>(value: T, delayMs: number, enabled: boolean): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (!enabled) {
      setDebouncedValue(value);
      return;
    }

    const timer = window.setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => window.clearTimeout(timer);
  }, [value, delayMs, enabled]);

  return enabled ? debouncedValue : value;
}
